// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"edb0bf36","85":"5cc92cce","86":"976f9cff","274":"07e62f6b","403":"a355dd8d","483":"86ca6842","682":"a62b6082","683":"2faf0c80"}[chunkId] + ".chunk.js";
};